import React from "react";
import * as translator from "../../../../../utils/translator";

interface Props {
  language: string;
  translationPrefix: string;
}

const MyAccountStoreHeader: React.FC<Props> = ({ language, translationPrefix }) => {
  const title = translator.translate(language, "my_account", `${translationPrefix}/header/title`);
  const subtitle = translator.translate(language, "my_account", `${translationPrefix}/header/subtitle`);

  return (
    <div className="mb-6">
      <h1 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-2">{title}</h1>
      {/* Subtitle contains <strong> runs (e.g. "3–5 Werktagen") that the design
          emphasizes. Content comes from our own translation files, not user
          input, so rendering it as HTML is safe here. */}
      <p
        className="text-base text-gray-600 [&_strong]:font-semibold"
        dangerouslySetInnerHTML={{ __html: subtitle }}
      />
    </div>
  );
};

export default MyAccountStoreHeader;
